import { render, staticRenderFns } from "./editBank.vue?vue&type=template&id=0e15cbe2&scoped=true&"
import script from "./editBank.vue?vue&type=script&lang=js&"
export * from "./editBank.vue?vue&type=script&lang=js&"
import style0 from "./editBank.vue?vue&type=style&index=0&id=0e15cbe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e15cbe2",
  null
  
)

export default component.exports